import { authService } from "../../services/authService";
import { useAuthStore } from "../../store/authStore";

export const useAuthActions = () => {
  const setAuth = useAuthStore((state) => state.setAuth);
  const logout = useAuthStore((state) => state.logout);
  const passwordSetSuccess = useAuthStore((state) => state.passwordSetSuccess);

  // ورود با موبایل و رمز عبور (داستان کاربر ۴)
  const loginPassword = async (phoneNumber, password) => {
    const data = await authService.loginWithPassword(phoneNumber, password);
    setAuth(data);
    return data;
  };

  // ورود سریع با موبایل و OTP (داستان کاربر ۵)
  const loginOTP = async (phoneNumber, otp) => {
    const data = await authService.loginWithOTP(phoneNumber, otp);
    setAuth(data);
    return data;
  };

  // ثبت‌نام مشتری جدید (داستان کاربر ۱)
  const register = async ({ phoneNumber, fullName, password, passwordConfirm, otp }) => {
    const data = await authService.registerCustomer({
      phoneNumber,
      fullName,
      password,
      passwordConfirm,
      otp,
    });
    setAuth(data);
    return data;
  };

    // ایجاد کاربر جدید توسط ادمین (داستان کاربر ۲)
  const adminCreateUser = async ({ phoneNumber, fullName, role }) => {
    return await authService.adminCreateUser({
      phoneNumber,
      fullName,
      role });
  };

  // ثبت اولین رمز عبور برای کاربران ایجاد شده توسط ادمین (داستان کاربر ۳)
  const setInitialPassword = async (newPassword, newPasswordConfirm) => {
    const response = await authService.setInitialPassword(newPassword, newPasswordConfirm);
    passwordSetSuccess(); // بروزرسانی استور
    return response;
  };

  // تغییر رمز عبور در پنل کاربری با رمز عبور فعلی (داستان کاربر ۸)
  const changePasswordWithOld = async (oldPassword, newPassword, newPasswordConfirm) => {
    return await authService.changePasswordWithOld(oldPassword, newPassword, newPasswordConfirm);
  };

  // تغییر رمز عبور در پنل با تایید پیامکی OTP (داستان کاربر ۸ جایگزین)
  const changePasswordWithOTP = async ({ phoneNumber, otp, newPassword, newPasswordConfirm }) => {
    return await authService.changePasswordWithOTP({
      phoneNumber,
      otp,
      newPassword,
      newPasswordConfirm,
    });
  };

  // بازنشانی رمز عبور فراموش شده (داستان کاربر ۹)
  const forgotPassword = async ({ phoneNumber, otp, newPassword, newPasswordConfirm }) => {
    return await authService.forgotPassword({
      phoneNumber,
      otp,
      newPassword,
      newPasswordConfirm,
    });
  };

  return {
    loginPassword,
    loginOTP,
    register,
    setInitialPassword,
    changePasswordWithOld,
    changePasswordWithOTP,
    forgotPassword,
    adminCreateUser,
    logout,
  };
};
